import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PaymentFailed: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-amber-50 to-sky-50 flex flex-col">

      {/* Navigation */}
      <nav className="sticky top-0 z-50 bg-white/80 backdrop-blur-md border-b border-blue-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="text-blue-700 font-semibold hover:text-blue-900 transition-colors">
              ← Späť na hlavnú stránku
            </Link>
          </div>
        </div>
      </nav>

      <div className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="max-w-lg w-full text-center">

          {/* Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-gradient-to-br from-rose-400 to-red-500 flex items-center justify-center shadow-xl">
              <span className="text-4xl text-white font-bold">✕</span>
            </div>
          </div>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight mb-3">
            Platba sa nepodarila
          </h1>
          <p className="text-xl font-semibold text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-red-500 mb-4">
            Nevadí, môže sa to stať.
          </p>
          <p className="text-gray-600 text-base mb-10 max-w-md mx-auto leading-relaxed">
            Platba nebola dokončená a <strong className="text-gray-900">nebolo vám účtované nič</strong>. Skúste to prosím znova, alebo nás kontaktujte na{' '}
            <a href="mailto:diana@wavelynecode.com" className="text-blue-600 hover:text-blue-800 underline transition-colors">
              diana@wavelynecode.com
            </a>.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <button
              onClick={() => navigate('/payment')}
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-amber-500 text-white font-bold rounded-xl shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200"
            >
              Skúsiť znova
            </button>
            <Link
              to="/"
              className="px-8 py-4 border border-blue-200 text-blue-700 font-semibold rounded-xl hover:bg-blue-50 transition-all duration-200"
            >
              ← Hlavná stránka
            </Link>
          </div>

          {/* Reassurance */}
          <div className="bg-white border border-blue-100 rounded-xl p-4 text-left shadow-sm">
            <p className="text-gray-600 text-sm">
              🔒 <strong className="text-gray-900">Bezpečnosť:</strong> Vaše platobné údaje sú spracované priamo cez Viva Wallet. My k nim nemáme prístup.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
